import { render, staticRenderFns } from "./stationed_account_record_detail.vue?vue&type=template&id=2c796bce"
import script from "./stationed_account_record_detail.vue?vue&type=script&lang=js"
export * from "./stationed_account_record_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports